"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AlarmDualList = void 0;

var _react = _interopRequireDefault(require("react"));

var _hooks = require("@nicbase/hooks");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

var _commonDualList = _interopRequireDefault(require("./common-dual-list"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AlarmDualList = function AlarmDualList(_ref) {
  var selectedAlarms = _ref.selectedAlarms,
      allAlarmsSelected = _ref.allAlarmsSelected,
      _onChange = _ref.onChange,
      portalId = _ref.portalId;

  var _usePortalAlarms = (0, _hooks.usePortalAlarms)(portalId),
      _usePortalAlarms$data = _usePortalAlarms.data,
      alarms = _usePortalAlarms$data === void 0 ? [] : _usePortalAlarms$data;

  var items = Object.values(alarms).map(function (alarm) {
    return {
      id: alarm.id,
      label: alarm.name
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_nicbaseForms.SectionHeader, {
    icon: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Alarms, null),
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "duallist.alarms",
      tagName: "span"
    })
  }, /*#__PURE__*/_react["default"].createElement(_commonDualList["default"], {
    items: items,
    allItemsSelected: allAlarmsSelected,
    selectedItems: selectedAlarms,
    onChange: function onChange(_ref2) {
      var allItemsSelected = _ref2.allItemsSelected,
          selectedItems = _ref2.selectedItems;
      return _onChange({
        allAlarmsSelected: allItemsSelected,
        selectedAlarms: selectedItems
      });
    }
  }));
};

exports.AlarmDualList = AlarmDualList;
AlarmDualList.defaultProps = {
  allAlarmsSelected: true,
  selectedAlarms: [],
  onChange: function onChange() {}
};
var _default = AlarmDualList;
exports["default"] = _default;